import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);


type FormattedUTCDateProps = {
    date?: Date | null;
};

export const FormattedUTCDate: React.FC<FormattedUTCDateProps> = ({ date }) => {
    if (!date) {
        return null;
    }

    return <>{dayjs.utc(date).format("L LTS")}</>;
};
